export default "__VITE_ASSET__DkMwX$qd__"